export default __webpack_public_path__ + "static/Nicholas-dbac8b6734f40aa64c7f7c7463558929.jpeg";